import { render, staticRenderFns } from "./addNewFields.vue?vue&type=template&id=5c233940"
import script from "./addNewFields.vue?vue&type=script&lang=js"
export * from "./addNewFields.vue?vue&type=script&lang=js"
import style0 from "./addNewFields.vue?vue&type=style&index=0&id=5c233940&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports